// src/services/unitService.jsx
import http from "./http";

/* =========================
   ADD UNIT
   POST /units?action=add
========================= */
export const addUnit = async (payload) => {
  const res = await http.post("units?action=add", {
    unit_name: payload.unit_name,
    description: payload.description,
  });

  return res.data;
};

/* =========================
   UPDATE UNIT
   POST /units?action=update
========================= */
export const updateUnit = async (id, payload) => {
  const res = await http.post("units?action=update", {
    id: id,
    unit_name: payload.unit_name,
    description: payload.description,
  });

  return res.data;
};

/* =========================
   GET ALL UNITS
   GET /units?action=get_all
========================= */

export const getUnits = async () => {
  const res = await http.get("units?action=get_all");
  return res.data;
};


/* =========================
   GET SINGLE UNIT
   GET /units?action=get&id=ID
========================= */
export const getUnitById = async (id) => {
  const res = await http.get(`units?action=get&id=${id}`);
  return res.data;
};

/* =========================
   DELETE UNIT
   POST /units?action=delete
========================= */
export const deleteUnit = async (id) => {
  const res = await http.post("units?action=delete", { id });
  return res.data;
};
